// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/components/spinner.scss
// module id = 408
// module chunks = 0